export default __webpack_public_path__ + "static/media/hht1_ep11_timeline_q05_b.06c6eb89.png";